<template>
  <div class="container flex flex-col">
    <p id="purple" class="text-4xl inline-block align-middle py-9">研究活動</p>
    <p class="text-3xl underline">主著</p>
    <div class="flex justify-between items-center grid grid-cols-1 md:grid-cols-2">
      <div class="flex justify-center flex-wrap w-3/4 mx-auto">
        <div class="max-w-md rounded-md overflow-hidden border-2 my-5 m-3 h-80 md:h-96">
          <img src="http://nkmr-lab.org/wp-content/uploads/2021/03/21698cb2fb76c0330b4cbc15a7a09757.png" class="border-b-2" />
          <div class="flex flex-col w-full my-2 p-3 h-32">
            <a href=https://dl.nkmr-lab.org/papers/297 class="font-bold">化粧品に対するクチコミの信憑性判定に</br>向けたクチコミ文章の調査 </a> </div>
          <p>2021/03/01</p>
        </div>
      </div>

      <div class="flex justify-center flex-wrap w-3/4 mx-auto">
        <div class="max-w-md rounded-md overflow-hidden border-2 my-5 m-3 h-80 md:h-96">
          <img src="http://dl.nkmr-lab.org/api/files/5d6fb4e353cac56c32ecb72b" class="border-b-2" />
          <div class="flex flex-col w-full my-2 p-3 h-32">
            <a href=https://dl.nkmr-lab.org/papers/194 class="font-bold">フォントと味の印象が商品選択行動に</br>及ぼす影響 </a> </div>
          <p>2019/09/05</p>
        </div>
      </div>
    </div>

    <p class="text-3xl mt-20 underline">共著</p>
    <div class="flex justify-between items-center grid grid-cols-1 md:grid-cols-2">
      <div class="flex justify-center flex-wrap w-3/4 mx-auto">
        <div class="max-w-md rounded-md overflow-hidden border-2 my-5 m-3 h-80 md:h-96">
          <img src="http://dl.nkmr-lab.org/api/files/5fc631ef6c45f44fdb0ea726" class="border-b-2" />
          <div class="flex flex-col w-full my-2 p-3 h-32">
            <a href="https://dl.nkmr-lab.org/papers/286" class="font-bold">記憶対象の文字の太さの違いが</br>記憶容易性に及ぼす影響</a>
          </div>
          <p>2020/12/01</p>
        </div>
      </div>

      <div class="flex justify-center flex-wrap w-3/4 mx-auto">
        <div class="max-w-md rounded-md overflow-hidden border-2 my-5 m-3 h-80 md:h-96">
          <img src="http://dl.nkmr-lab.org/api/files/5f509d2f933a5319b1c7eddb" class="border-b-2" />
          <div class="flex flex-col w-full my-2 p-3 h-32">
            <a href="https://dl.nkmr-lab.org/papers/277" class="font-bold">文字の見た目が記憶に及ぼす影響</a>
          </div>
          <p>2020/08/28</p>
        </div>
      </div>

      <div class="flex justify-center flex-wrap w-3/4 mx-auto">
        <div class="max-w-md rounded-md overflow-hidden border-2 my-5 m-3 h-80 md:h-96">
          <img src="http://dl.nkmr-lab.org/api/files/5f183b20933a5319b1c7edc4" class="border-b-2" />
          <div class="flex flex-col w-full my-2 p-3 h-32">
            <a href="https://dl.nkmr-lab.org/papers/275" class="font-bold">Comparison of the Remembering Ability by the
              Difference Between Handwriting and Typeface</a>
          </div>
          <p>2020/07/10</p>
        </div>
      </div>

      <div class="flex justify-center flex-wrap w-3/4 mx-auto">
        <div class="max-w-md rounded-md overflow-hidden border-2 my-5 m-3 h-80 md:h-96">
          <img src="http://dl.nkmr-lab.org/api/files/5cda44fb53cac56c32ecb5cf" class="border-b-2" />
          <div class="flex flex-col w-full my-2 p-3 h-32">
            <a href="https://dl.nkmr-lab.org/papers/182" class="font-bold">手書きとフォントの文字形状の違いによる</br>記憶効果の比較</a>
          </div>
          <p>2019/05/17</p>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
  export default {
    components: {}
  }
</script>

<style lang="css" scoped>
  img {
    height: 200px;
    width: 100%;
    object-fit: cover;
  }

  @media screen and (max-width: 480px) {
    img {
      /* 480px以下に適用されるCSS（スマホ用） */
      height: 150px;
      width: 100%;
      object-fit: cover;
    }
  }

  p, a{
    color:#432444;
  }
</style>